// extracted by mini-css-extract-plugin
export default {"separator":"TickerSeparator_separator__kXD5u"};